const getLayoutType = () => {
    const currentPath = window.location.pathname;
    if (currentPath.includes('auth.php')) {
        return 'auth';
    }

    return 'main';
};

export default getLayoutType;
